import { atom, map } from 'nanostores'
import type { ShopifyCustomer } from '@/types/shopify'
import type { Campaign } from '@/models/campaign'
import type { MealProgramSubscription } from '@/models/meal-program-subscription'
import type { ProductSubscription } from '@/models/product-subscription'
import { persistentAtom } from '@nanostores/persistent'

export type Customer = ShopifyCustomer & { simpleId: number }

export const $isDeveloper = atom<boolean>(false)
export const $customer = persistentAtom<Customer | null>('customer', null, {
  encode: JSON.stringify,
  decode: JSON.parse,
})
export const $subscriptions = atom<
  Array<MealProgramSubscription | ProductSubscription>
>([])
export const $subscriptionIdToCampaingsMap = map<Record<string, Campaign[]>>({})
export const $promises = map<Record<string, Promise<any> | undefined>>()
export const $authenticationToken = persistentAtom<string>(
  'authentication_token',
  '',
)

export const loggables = {
  'account/$isDeveloper': $isDeveloper,
  'account/$customer': $customer,
  'account/$subscriptions': $subscriptions,
  'account/$subscriptionIdToCampaingsMap': $subscriptionIdToCampaingsMap,
  'account/$authenticationToken': $authenticationToken,
  // 'account/$promises': $promises,
}
